import { Stack } from "@mantine/core"
import { LabelWithTooltip, TagsInput } from "@tfg/ui"

import { FormFieldConfig } from "~/pages/Admin/components/form.types"

export const TagsInputField = (fields: FormFieldConfig, form: any) => {
  return (
    <Stack gap="var(--mantine-spacing-xxs)">
      {fields.tooltip && (
        <LabelWithTooltip
          label={fields.label}
          hoverHelperText={fields.tooltip}
          justify="space-between"
          fw={600}
          withAsterisk={fields.required ?? false}
        />
      )}
      <TagsInput
        key={fields.name}
        label={!fields.tooltip ? fields.label : undefined}
        labelProps={{
          fz: "xs",
          fw: 600,
        }}
        size="xs"
        classNames={fields.customClass}
        clearable
        styles={{
          pill: {
            backgroundColor: "var(--mantine-color-primary-4)",
            color: "var(--mantine-color-white)",
          },
        }}
        onChange={(value) => {
          form.setFieldValue(fields.name, value)
        }}
        data={fields.options?.map((option) => ({
          label: option.label,
          value: option.value,
        }))}
        disabled={fields.disabled}
        {...form.getInputProps(fields.name)}
      />
    </Stack>
  )
}
